import React from "react";
import styled from "styled-components";
import { focalPointToCss } from "../utils/focalPoint";
const ImageHTML = React.forwardRef(({ media, ...imgProps }, ref) => {
    return (React.createElement("img", { src: media.url, alt: media.accessibilityText, ref: ref, "data-focalpoint": media.focalPoint, ...imgProps }));
});
ImageHTML.displayName = "ImageHTML";
const CssCroppedImage = styled(ImageHTML) `
  object-position: ${({ media: { focalPoint } }) => focalPointToCss(focalPoint)};
`;
export default CssCroppedImage;
//# sourceMappingURL=CssCroppedImage.js.map